export const getExtension = (file: File) => file?.name?.split('.')?.pop()?.toLowerCase() ?? '';
